import TrackingHttp from '../../trackingHttp';

class UserApprovalServices {
  static async createApproval(data) {
    return TrackingHttp.post('/user-approvals', data);
  }

  static async updateApprovalStatus(id, data) {
    return TrackingHttp.update(`/user-approvals/${id}`, data);
  }

  static async getApprovals(id) {
    return TrackingHttp.get(`/user-approvals/${id}`);
  }

  static async deleteApproval(id) {
    return TrackingHttp.delete(`/user-approvals/${id}`);
  }
  static async getAllUserApprovalsbyOwnerId(ownerId) {
    return TrackingHttp.get(`/user-approvals/owner/${ownerId}`);
  }

  static async bulkApproveAllByOwnerId(ownerId, data) {
    return TrackingHttp.post(`/user-approvals/owner/${ownerId}/approve-all-efficient`,data)
  }
  static async bulkUpdateSelectedUserApprovals(ownerId, data) {
    return TrackingHttp.post(`/user-approvals/owner/${ownerId}/approve-selected-efficient`, data);
  }

  static async getUserApprovalCountByOwnerId(ownerId) {
    return TrackingHttp.get(`/user-approvals/owner/${ownerId}/stats`);
  }
}

export default UserApprovalServices;
